import React from 'react';
export function HeroSection() {
  return <section className="pt-[25px] pb-[30px] px-[15px] bg-[#F8F6FF]" data-id="element-143">
      <div className="max-w-[650px] mx-auto" data-id="element-144">
        <p className="text-[#DC2626] font-[800] uppercase text-[12px] sm:text-[13px] mb-[10px] tracking-[0px] text-center" data-id="element-145">
          ⚠️ Tu familiar con cáncer necesita que seas su apoyo. ¿Sabes cómo? ⚠️
        </p>

        <h1 className="text-[24px] sm:text-[28px] leading-[1.3] mb-[15px] font-[800] text-[#1A1035] font-['Montserrat'] text-center" data-id="element-146">
          <strong data-id="element-147">El Apoyo Incondicional</strong>
          <br data-id="element-148" />
          <span className="relative inline-block mt-2" data-id="element-149">
            <span className="relative z-10 text-[#7C3AED] font-[900] text-[26px] sm:text-[32px]" style={{
            background: 'linear-gradient(180deg, transparent 50%, rgba(167,139,250,0.4) 50%)',
            padding: '0 6px',
            animation: 'highlightPulse 2s ease-in-out infinite'
          }} data-id="element-150">
              "La guía que ningún médico te va a recetar."
            </span>
          </span>
        </h1>

        <h2 className="text-[16px] sm:text-[18px] font-[600] text-[#2D1B69] text-center mb-[20px] max-w-[550px] mx-auto" data-id="element-151">
          Porque ellos curan el cuerpo. <br className="hidden sm:block" data-id="element-152" />
          <span className="text-[#7C3AED]" data-id="element-153">
            Tú eres el único que puede curar el alma.
          </span>
        </h2>

        <p className="text-[15px] sm:text-[16px] leading-[1.6] max-w-[600px] mx-auto text-[#4B5563] mb-[25px] text-center" data-id="element-154">
          Mientras lees esto, tu familiar con cáncer está esperando que tú seas
          la persona que él/ella necesita. ¿Y si nunca aprendes cómo?
        </p>

        {/* Product Image */}
        <div className="mb-[25px] rounded-[12px] overflow-hidden shadow-[0_10px_30px_rgba(124,58,237,0.25)] w-full max-w-[340px] mx-auto" data-id="element-155">
          <img src="https://cdn.magicpatterns.com/uploads/wpt6H7fokBE4FDVqWg5g2p/1apoyo.png" alt="El Apoyo Incondicional — Guía Práctica para Familiares" className="w-full block" data-id="element-156" />
        </div>

        <a className="block w-full max-w-[380px] mx-auto bg-gradient-to-br from-[#7C3AED] to-[#6D28D9] text-white border-none p-[16px] text-[18px] font-[700] rounded-[50px] cursor-pointer shadow-[0_8px_20px_rgba(124,58,237,0.3)] text-center no-underline uppercase font-['Montserrat'] animate-pulse-custom hover:transform hover:-translate-y-[3px] hover:scale-[1.02] hover:shadow-[0_12px_25px_rgba(124,58,237,0.5)] transition-all duration-400" href="#elige-tu-plan" data-id="element-157">
          👉 QUIERO SER SU APOYO
        </a>

        <div className="text-[11px] mt-[12px] text-[#6B7280] text-center font-medium" data-id="element-158">
          ⚡ Descarga inmediata · Oferta por tiempo limitado
        </div>
      </div>
    </section>;
}